import { render, staticRenderFns } from "./PhotoZoom.vue?vue&type=template&id=41f09a5e&"
import script from "./PhotoZoom.vue?vue&type=script&lang=js&"
export * from "./PhotoZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports